/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateEntitiesEntitlementsRelation} from '../models/UpdateEntitiesEntitlementsRelation';
import type {UpdateUserEntitlementsResult} from '../models/UpdateUserEntitlementsResult';

export interface BulkAssignUsersEntitlements$Request {
    updateEntitiesEntitlementsRelation: UpdateEntitiesEntitlementsRelation;
    reason?: string;
}

export interface BulkAssignUsersEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkAssignUsersEntitlementsRequest = createAction<PayloadData<void, BulkAssignUsersEntitlements$Request>>('BULK_ASSIGN_USERS_ENTITLEMENTS__BULK_ASSIGN_USERS_ENTITLEMENTS__REQUEST');
export const bulkAssignUsersEntitlementsSuccess = createAction<PayloadData<string, BulkAssignUsersEntitlements$Request>>('BULK_ASSIGN_USERS_ENTITLEMENTS__BULK_ASSIGN_USERS_ENTITLEMENTS__SUCCESS');
export const bulkAssignUsersEntitlementsFailure = createAction<PayloadData<Error, BulkAssignUsersEntitlements$Request, true>>('BULK_ASSIGN_USERS_ENTITLEMENTS__BULK_ASSIGN_USERS_ENTITLEMENTS__FAILURE');

export const bulkAssignUsersEntitlementsActions = [
    bulkAssignUsersEntitlementsRequest,
    bulkAssignUsersEntitlementsSuccess,
    bulkAssignUsersEntitlementsFailure
] as const;

/**
 * @param {UpdateEntitiesEntitlementsRelation} meta.updateEntitiesEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkAssignUsersEntitlements = (meta: BulkAssignUsersEntitlements$Request, config?: BulkAssignUsersEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkAssignUsersEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/users/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateEntitiesEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignUsersEntitlementsProgress$Request {
    id: string;
}

export interface GetAssignUsersEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignUsersEntitlementsProgressRequest = createAction<PayloadData<void, GetAssignUsersEntitlementsProgress$Request>>('BULK_ASSIGN_USERS_ENTITLEMENTS__GET_ASSIGN_USERS_ENTITLEMENTS_PROGRESS__REQUEST');
export const getAssignUsersEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetAssignUsersEntitlementsProgress$Request>>('BULK_ASSIGN_USERS_ENTITLEMENTS__GET_ASSIGN_USERS_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getAssignUsersEntitlementsProgressFailure = createAction<PayloadData<Error, GetAssignUsersEntitlementsProgress$Request, true>>('BULK_ASSIGN_USERS_ENTITLEMENTS__GET_ASSIGN_USERS_ENTITLEMENTS_PROGRESS__FAILURE');

export const getAssignUsersEntitlementsProgressActions = [
    getAssignUsersEntitlementsProgressRequest,
    getAssignUsersEntitlementsProgressSuccess,
    getAssignUsersEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignUsersEntitlementsProgress = (meta: GetAssignUsersEntitlementsProgress$Request, config?: GetAssignUsersEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignUsersEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/entitlements/assign/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignUsersEntitlementsResult$Request {
    id: string;
}

export interface GetAssignUsersEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignUsersEntitlementsResultRequest = createAction<PayloadData<void, GetAssignUsersEntitlementsResult$Request>>('BULK_ASSIGN_USERS_ENTITLEMENTS__GET_ASSIGN_USERS_ENTITLEMENTS_RESULT__REQUEST');
export const getAssignUsersEntitlementsResultSuccess = createAction<PayloadData<UpdateUserEntitlementsResult, GetAssignUsersEntitlementsResult$Request>>('BULK_ASSIGN_USERS_ENTITLEMENTS__GET_ASSIGN_USERS_ENTITLEMENTS_RESULT__SUCCESS');
export const getAssignUsersEntitlementsResultFailure = createAction<PayloadData<Error, GetAssignUsersEntitlementsResult$Request, true>>('BULK_ASSIGN_USERS_ENTITLEMENTS__GET_ASSIGN_USERS_ENTITLEMENTS_RESULT__FAILURE');

export const getAssignUsersEntitlementsResultActions = [
    getAssignUsersEntitlementsResultRequest,
    getAssignUsersEntitlementsResultSuccess,
    getAssignUsersEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignUsersEntitlementsResult = (meta: GetAssignUsersEntitlementsResult$Request, config?: GetAssignUsersEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignUsersEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopBulkActions$Request {
    id: string;
}

export interface StopBulkActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopBulkActionsRequest = createAction<PayloadData<void, StopBulkActions$Request>>('BULK_ASSIGN_USERS_ENTITLEMENTS__STOP_BULK_ACTIONS__REQUEST');
export const stopBulkActionsSuccess = createAction<PayloadData<void, StopBulkActions$Request>>('BULK_ASSIGN_USERS_ENTITLEMENTS__STOP_BULK_ACTIONS__SUCCESS');
export const stopBulkActionsFailure = createAction<PayloadData<Error, StopBulkActions$Request, true>>('BULK_ASSIGN_USERS_ENTITLEMENTS__STOP_BULK_ACTIONS__FAILURE');

export const stopBulkActionsActions = [
    stopBulkActionsRequest,
    stopBulkActionsSuccess,
    stopBulkActionsFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopBulkActions = (meta: StopBulkActions$Request, config?: StopBulkActions$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopBulkActionsActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

